<div class="row main-content">
    <div class="w15">
        <div class="sidebar">
            <ul>
                <li *ngIf="checkOVRInAgencyCode==='false'"  routerLink="/dashboard/sales-home"><img src="./assets/images/home.svg"><a>Home</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'"  (click)="goToQuotePurchase()" [ngClass]="{'op5': hideQuotePurchase==='true' || agentIdActive=='false' || !isDisabled}"><img src="./assets/images/quotePurchase.svg"><a>QUOTE / PURCHASE</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" class="active" routerLink="/dashboard/policy-search"><img src="./assets/images/policySearch.svg"><a>POLICY SEARCH</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToSaveQuote()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/home.svg"><a>SAVED QUOTES</a></li>
                <!-- <li routerLink="/dashboard/Groups"><img src="./assets/images/home.svg"><a>GROUPS</a></li> -->
                <li (click)="goToforms()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/file-text.svg"><a>POLICY DOCUMENTS</a></li>
                <!-- <li routerLink="/dashboard/agency-admin"><img src="./assets/images/archive.svg"><a>AGENCY ADMIN</a></li> -->
                <li routerLink="/dashboard/sales-report"><img src="./assets/images/pie-chart.svg"><a>REPORTS</a></li>
                <li (click)="goToResources()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/resources.svg"><a>RESOURCES</a></li>
            </ul>
        </div>
    </div>
    <div class="w85">
        <div>
          <div class="whitebox p-3">
            <label class="bold fs-18 m-0 cp" (click)="backToPolicySearch()">Policy Search</label>
            <label class="bold fs-20 txt-red m-0">&nbsp;&nbsp;>&nbsp;&nbsp;</label>
            <label class="bold fs-18 txt-red m-0 cp">{{policyNumber}}</label>
            <label class="bold fs-20 txt-red m-0">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;</label>
            <label class="m-0 txt-red" *ngIf="leadStatus =='Deactivated'">Your account is deactivated, please contact <a class="txt-dec" href="https://www.travelance.ca/contact-us/">Support Services</a> for assistance.</label>
            <label class="m-0 fs-14 cp ml-2 float-right" (click)="nextClickPolicy(policyId)">Next<img  class="ml-1" src="./assets/images/unnext.png"></label>
            <label class="m-0 fs-14 cp mr-2 float-right" (click)="previousClickPolicy(policyId)"><img  class="mr-1" src="./assets/images/unback.png">Prev</label>
        </div>
          <div class="row p-2">
            <div class="col-sm-8 col-md-9 col-lg-9 col-xl-9 col-8">
                <button type="button"   class="btns txt-red"   [ngClass]="{'op5':policyIDDetail[0]?.status?.status=='Refunded' || showBtnChange==false || (agentIdActive==='false' && agentIdInactiveNewAgency==false),'disabled-button': leadStatus =='Deactivated'}" (click)="onClickRefundPolicy()" [disabled]="leadStatus =='Deactivated'">Full Refund</button>
                <button type="button" class="btns txt-blue3" [ngClass]="{'op5':policyIDDetail[0]?.status?.status=='Refunded' || showBtnChange==false || (agentIdActive==='false' && agentIdInactiveNewAgency==false),'disabled-button': leadStatus =='Deactivated'}" (click)="onClickChangePolicy()" [disabled]="leadStatus =='Deactivated'">Change Policy</button>
                <!-- <button type="button"  class="btns w215 green" (click)="onClickEditBillingInfo()">Edit Billing Information</button> -->
                <button type="button" class="btns txt-lightblack2" [ngClass]="{'op5': agentIdActive==='false'}" (click)="viewCOC()">View COC</button>
                <!-- <label class="m-0 cp" ><img title="Logs" (click)="onLogsDetails()" class="ml-3" src="./assets/images/leadslogs.png"></label> -->
            </div>
            <div class="col-sm-4 col-md-3 col-lg-3 col-xl-3 col-4 text-right" >
                <button *ngIf="editEffectiveDate || editContactInfoName || editContactInfoAdderss || editContactInfoEmail || editContactInfoLanguage || editPurchaserInfoName || editPurchaserInfoAddress || editPurchaserInfoPhoneOne || editPurchaserInfoEmail || editPurchaserInfoPhoneTwo || editPurchaserInfoLanguage" type="button" class=" fs-14 semi-bold addbtn mr-3" (click)="updatePolicyInformation()">Update</button>
                <button *ngIf="editEffectiveDate || editContactInfoName || editContactInfoAdderss || editContactInfoEmail || editContactInfoLanguage || editPurchaserInfoName || editPurchaserInfoAddress || editPurchaserInfoPhoneOne || editPurchaserInfoEmail || editPurchaserInfoPhoneTwo || editPurchaserInfoLanguage" type="button" class=" fs-14 semi-bold cancalbtn mr-3" (click)="cancelEditPencilIcon()">Cancel</button>
            </div>
          </div>
          <div class="border-bottom" ></div>
          <!-- <div class="p-3" *ngFor="let item of policyIDDetail;let i=index">
              <div class="whitebox1">
                  <label class="bold fs-16 txt-red m-0">Policy Basics:</label>
                  <label class="bold fs-16 green m-0">&nbsp;&nbsp;{{item.status.status}}</label>
                  <div class="clear5"></div>
                  <div class="border-bottom"></div>
                  <div class="clear5"></div>
                  <div class="row">
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Agency</label>
                          <div class="bold fs-14 cp clickcolor" (click)="onAgencyNavigation($event,item.agentId.agencyMGA.id)">{{item.agentId.agencyMGA.agencyName}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Agent</label>
                        <div class="bold fs-14 cp clickcolor" (click)="onLeadNavigation($event,item.agentId.lead.id)">{{item.agentId.lead.firstName}} {{item.agentId.lead.lastName}}</div>
                    </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Departure</label>
                          <div class="bold fs-14 purple">{{item.departure}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Destination</label>
                          <div class="bold fs-14 purple">{{item.destination}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Sales Type</label>
                          <div class="bold fs-14 purple"></div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Group</label>
                          <div class="bold fs-14 purple"></div>
                      </div>
                  </div>
                  <div class="clear10"></div>
                  <div class="row">
                      <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                          <label class="regular fs-14 txt-lightblack2">Total Admin Fee</label>
                          <div class="bold fs-14 purple">{{item.totalAdminFee}}</div>
                      </div>
                  </div>
              </div>
              <div class="clear20"></div>
              <div class="whitebox1">
                  <label class="bold fs-16 txt-red m-0">Policy Dates</label>
                  <div class="clear5"></div>
                  <div class="border-bottom"></div>
                  <div class="clear5"></div>
                  <div class="row">
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Effective</label>
                          <div class="bold fs-14 purple">{{item.effectiveDate | date:'MM/dd/yyyy'}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Expiry</label>
                          <div class="bold fs-14 purple">{{item.expiryDate | date:'MM/dd/yyyy'}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Days</label>
                          <div class="bold fs-14 purple">{{item.noOfDays}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Application</label>
                          <div class="bold fs-14 purple">{{item.applicationDate | date:'MM/dd/yyyy'}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Trip Deposit
                        </label>
                          <div class="bold fs-14 purple"></div>
                      </div>
                  </div> -->
          <div class="p-2" *ngFor="let item of policyIDDetail;let i=index">
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 p-1">
                    <div class="whitebox1 h250">
                        <label class="bold fs-16 txt-red m-0">Policy Basics:</label>
                        <label class="bold fs-16 green m-0">&nbsp;&nbsp;{{item.status.status}}</label>
                        <div class="row">
                            <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                <label class="regular fs-14 txt-lightblack2">Agency:</label>
                            </div>
                            <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                                <label class="bold fs-14 purple cp" *ngIf="item.agentId.agencyMGA!=null">{{item.agentId.agencyMGA.agencyName}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                <label class="regular fs-14 txt-lightblack2">Agent:</label>
                            </div>
                            <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                                <label class="bold fs-14 purple cp" *ngIf="item.agentId.lead!=null">{{item.agentId.lead.firstName}} {{item.agentId.lead.lastName}}</label>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                <label class="regular fs-14 txt-lightblack2">Departure:</label>
                            </div>
                            <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                                <label class="bold fs-14 purple">{{item.departure}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                <label class="regular fs-14 txt-lightblack2">Destination:</label>
                            </div>
                            <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                                <label class="bold fs-14 purple">{{item.destination}}</label>
                            </div>
                        </div> -->
                        <div class="row">
                            <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                <label class="regular fs-14 txt-lightblack2">Sales Type:</label>
                            </div>
                            <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                                <label class="bold fs-14 purple">{{item.salesType}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                <label class="regular fs-14 txt-lightblack2">Group:</label>
                            </div>
                            <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                                <label class="bold fs-14 purple"></label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                <label class="regular fs-14 txt-lightblack2">Total Admin Fee:</label>
                            </div>
                            <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                                <label class="bold fs-14 purple">{{item.totalAdminFee}}</label>
                            </div>
                        </div>
                    </div>
                </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 p-1">
                <div class="whitebox1 h250">
                    <label class="bold fs-16 txt-red m-0">Policy Dates</label>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Effective:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label [hidden]="editEffectiveDate" class="bold fs-14 purple">{{item.effectiveDate | date:'ddMMMyyyy'}}</label>
                            <input *ngIf="editEffectiveDate" class="form-control forminput inputstyle" [owlDateTimeTrigger]="dt90" [owlDateTime]="dt90" placeholder="ddMMMyyyy">
                            <owl-date-time #dt90 [pickerType]="'calendar'"></owl-date-time>
                            <img  *ngIf="policyIDDetail[0].status.status!=='Refunded' && showBtnChange==true && NonResidentSelected==false" class="hide3 cp olnone float-right" (click)="updateEffectiveDate()" src="./assets/images/pencilicon.svg">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Expiry:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label class="bold fs-14 purple">{{item.expiryDate | date:'ddMMMyyyy'}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Days:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label class="bold fs-14 purple">{{item.noOfDays}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Application:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label class="bold fs-14 purple">{{item.applicationDate | date:'ddMMMyyyy'}}</label>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Trip Deposit:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label class="bold fs-14 purple">Dummy</label>
                        </div>
                    </div> -->
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 p-1">
                <div class="whitebox1 h250" [ngClass]="{'hauto':editContactInfoAdderss==true}">
                    <label class="bold fs-16 txt-red m-0">Contact Information</label>
                    <div class="row myDIV3">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Name:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label [hidden]="editContactInfoName" class="bold fs-14 purple col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">{{item.policyInsureds[0].firstName}} {{item.policyInsureds[0].lastName}}</label>
                            <input type="text" [(ngModel)]="contactInfoFirstName" placeholder="First Name" *ngIf="editContactInfoName" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            <input type="text" [(ngModel)]="contactInfoLastName" placeholder="Last Name" *ngIf="editContactInfoName" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            <img  *ngIf="policyIDDetail[0].status.status!=='Refunded' && showBtnChange==true && NonResidentSelected==false" class="hide3 cp olnone float-right col-sm-1 col-md-1 col-lg-1 col-xl-1 col-12" (click)="updateContactInfoName()" src="./assets/images/pencilicon.svg">
                        </div>
                    </div>
                    <div class="row myDIV3">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Address:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label [hidden]="editContactInfoAdderss" class="bold fs-14 purple col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">{{item.primaryAddress1}} {{item.primaryAddress2}} {{item.primaryAddressCity}} {{item.primaryAddressProvince}} {{item.primaryAddressPostalCode}}</label>
                            <!-- <input type="text" [(ngModel)]="updateContactInfoAddress1" placeholder="Enter here" *ngIf="editContactInfoAdderss" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12"> -->
                            <input type="text" [(ngModel)]="updateContactInfoAddress1" (input)="callAddressApiCall(updateContactInfoAddress1)" placeholder="Enter here" *ngIf="editContactInfoAdderss" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            <div class="searchResultBox" *ngIf="showAddressResults1">
                                <div class="borderbottom">
                                    </div>
                                    <div class="row borderbottom p-1" *ngFor="let item of getPrimaryAddress">
                                      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <label class="fs-14 regular m-0 link cp" (click)="onClickSearchResultprimary(item)">{{item.place_name}}</label><br>
                                      </div>
                                    </div>
                                </div>
                            <input type="text" [(ngModel)]="updateContactInfoAddress2" placeholder="Enter here" *ngIf="editContactInfoAdderss" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            <input type="text" [(ngModel)]="updateContactInfoCity" placeholder="Enter here" *ngIf="editContactInfoAdderss" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            <input type="text" [(ngModel)]="updateContactInfoProvince" placeholder="Enter here" *ngIf="editContactInfoAdderss" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            
                            <input type="text" [(ngModel)]="updateContactInfoPostalCode" placeholder="Enter here" *ngIf="editContactInfoAdderss" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
    
                            <img  *ngIf="policyIDDetail[0].status.status!=='Refunded' && showBtnChange==true && NonResidentSelected==false"class="hide3 cp olnone float-right col-sm-1 col-md-1 col-lg-1 col-xl-1 col-12" (click)="updateContactInfoAdderss()" src="./assets/images/pencilicon.svg">
                        </div>
                    </div>
                    <div class="row myDIV3">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Email:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label [hidden]="editContactInfoEmail" class="bold fs-14 purple breakAll col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">{{item.purchaserEmailAddress}}</label>
                            <input type="text" [(ngModel)]="purchaserEmailAddress" placeholder="Enter here" *ngIf="editContactInfoEmail" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            <img *ngIf="policyIDDetail[0].status.status!=='Refunded' && showBtnChange==true && NonResidentSelected==false" class="hide3 cp olnone float-right col-sm-1 col-md-1 col-lg-1 col-xl-1 col-12" (click)="updateContactInfoEmail()" src="./assets/images/pencilicon.svg">
                        </div>
                    </div>
                    <div class="row myDIV3">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Language:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label [hidden]="editContactInfoLanguage" class="bold fs-14 purple col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">{{item.language}}</label>
                            <ng-select *ngIf="editContactInfoLanguage" placeholder="Select" class=" col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12 Tab" [(ngModel)]="contactInfoLanguage">
                                <ng-option value="English">English</ng-option>
                                <!-- <ng-option value="French">French</ng-option> -->
                              </ng-select>
                            <img *ngIf="policyIDDetail[0].status.status!=='Refunded' && showBtnChange==true && NonResidentSelected==false" class="hide3 cp olnone float-right col-sm-1 col-md-1 col-lg-1 col-xl-1 col-12" (click)="updateContactInfoLanguage()" src="./assets/images/pencilicon.svg">
                        </div>
                    </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 p-1">
                <div class="whitebox1 h250" [ngClass]="{'hauto':editPurchaserInfoAddress==true}">
                    <label class="bold fs-16 txt-red m-0">Purchaser Information</label>
                    <div class="row myDIV3">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Name:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label [hidden]="editPurchaserInfoName" class="bold fs-14 purple col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">{{item.purchaserName}}</label>
                            <input type="text" [(ngModel)]="purchaserFirstName" placeholder="Enter here" *ngIf="editPurchaserInfoName" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            <input type="text" [(ngModel)]="purchaserLastName" placeholder="Enter here" *ngIf="editPurchaserInfoName" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            <img *ngIf="policyIDDetail[0].status.status!=='Refunded' && showBtnChange==true && NonResidentSelected==false" class="hide3 cp olnone float-right col-sm-1 col-md-1 col-lg-1 col-xl-1 col-12" (click)="updatePurchaserInfoName()" src="./assets/images/pencilicon.svg">
                        </div>
                    </div>
                    <div class="row myDIV3">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Address:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label [hidden]="editPurchaserInfoAddress" class="bold fs-14 purple col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">{{item.purchaserAddress1}} {{item.purchaserAddress2}} {{item.purchaserAddressCity}} {{item.purchaserAddressProvince}} {{item.purchaserAddressPostalCode}}</label>
                            <!-- <input type="text" [(ngModel)]="updatePurchaserInfoAddress1" placeholder="Enter here" *ngIf="editPurchaserInfoAddress && NonResidentSelected==false" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12"> -->
                            <input type="text" [(ngModel)]="updatePurchaserInfoAddress1" (input)="callAddressApiCall2(updatePurchaserInfoAddress1)" placeholder="Enter here" *ngIf="editPurchaserInfoAddress && NonResidentSelected==false" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            <div class="searchResultBox" *ngIf="showAddressResults2">
                                <div class="borderbottom">
                                    </div>
                                    <div class="row borderbottom p-1" *ngFor="let item of getPrimaryAddress">
                                      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <label class="fs-14 regular m-0 link cp" (click)="onClickSearchResultprimaryPurcheser(item)">{{item.place_name}}</label><br>
                                      </div>
                                    </div>
                                </div>
                            <input type="text" [(ngModel)]="updatePurchaserInfoAddress2" placeholder="Enter here" *ngIf="editPurchaserInfoAddress && NonResidentSelected==false"class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            <input type="text" [(ngModel)]="updatePurchaserInfoCity" placeholder="Enter here" *ngIf="editPurchaserInfoAddress && NonResidentSelected==false" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            <input type="text" [(ngModel)]="updatePurchaserInfoProvince" placeholder="Enter here" *ngIf="editPurchaserInfoAddress" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            
                            <input type="text" [(ngModel)]="updatePurchaserInfoPostalCode" placeholder="Enter here" *ngIf="editPurchaserInfoAddress" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            <img *ngIf="policyIDDetail[0].status.status!=='Refunded' && showBtnChange==true && NonResidentSelected==false" class="hide3 cp olnone float-right col-sm-1 col-md-1 col-lg-1 col-xl-1 col-12" (click)="updatePurchaserInfoAddress()" src="./assets/images/pencilicon.svg">
                        </div>
                    </div>
                    <div class="row myDIV3">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Email:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label [hidden]="editPurchaserInfoEmail" class="bold fs-14 purple breakAll col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">{{item.purchaserEmailAddress}}</label>
                            <input type="text" [(ngModel)]="purchaserEmailAddress" placeholder="Enter here" *ngIf="editPurchaserInfoEmail" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">
                            <img  *ngIf="policyIDDetail[0].status.status!=='Refunded' && showBtnChange==true && NonResidentSelected==false" class="hide3 cp olnone float-right col-sm-1 col-md-1 col-lg-1 col-xl-1 col-12" (click)="updatePurchaserInfoEmail()" src="./assets/images/pencilicon.svg">
                        </div>
                    </div>
                    <div class="row myDIV3">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Phone 1:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label [hidden]="editPurchaserInfoPhoneOne" class="bold fs-14 purple col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">{{item.purchaserPhone1}}</label>
                            <input type="tel" onkeydown="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^[0-9()\-]+$]*/g,'');" [(ngModel)]="purchaserPhone1" placeholder="Enter here" *ngIf="editPurchaserInfoPhoneOne" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12" maxlength="15">
                            <img  *ngIf="policyIDDetail[0].status.status!=='Refunded' && showBtnChange==true && NonResidentSelected==false" class="hide3 cp olnone float-right col-sm-1 col-md-1 col-lg-1 col-xl-1 col-12" (click)="updatePurchaserInfoPhoneOne()" src="./assets/images/pencilicon.svg">
                        </div>
                    </div>
                    <div class="row myDIV3">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Phone 2:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label [hidden]="editPurchaserInfoPhoneTwo" class="bold fs-14 purple col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">{{item.purchaserPhone2}}</label>
                            <input type="tel" onkeydown="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^[0-9()\-]+$]*/g,'');" [(ngModel)]="purchaserPhone2" placeholder="Enter here" *ngIf="editPurchaserInfoPhoneTwo" class="Tab forminput1 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12" maxlength="15">
                            <img *ngIf="policyIDDetail[0].status.status!=='Refunded' && showBtnChange==true && NonResidentSelected==false" class="hide3 cp olnone float-right col-sm-1 col-md-1 col-lg-1 col-xl-1 col-12" (click)="updatePurchaserInfoPhoneTwo()" src="./assets/images/pencilicon.svg">
                        </div>
                    </div>
                    <div class="row myDIV3">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-lightblack2">Language:</label>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                            <label [hidden]="editPurchaserInfoLanguage" class="bold fs-14 purple col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12">{{item.language}}</label>
                            <ng-select *ngIf="editPurchaserInfoLanguage" [(ngModel)]="purchaserlanguage" placeholder="Select" class=" col-sm-11 col-md-11 col-lg-11 col-xl-11 col-12 Tab">
                                <ng-option value="English">English</ng-option>
                                <!-- <ng-option value="French">French</ng-option> -->
                              </ng-select>
                            <img  *ngIf="policyIDDetail[0].status.status!=='Refunded' && showBtnChange==true && NonResidentSelected==false" class="hide3 cp olnone float-right col-sm-1 col-md-1 col-lg-1 col-xl-1 col-12" (click)="updatePurchaserInfoLanguage()" src="./assets/images/pencilicon.svg">
                        </div>
                    </div>
                </div>
              </div>
            </div>
              <div class="clear10"></div>
              <div class="whitebox1">
                  <label class="bold fs-16 txt-red m-0">Plan:</label>
                  <label class="bold fs-16 txt-red m-0">&nbsp;&nbsp;{{item.planName}}</label>
                  <div class="insuredBox" *ngFor="let data of item.policyInsureds; let j=index">
                    <div class="row">
                        <label class="regular fs-14 txt-lightblack2 mb-0">Insured {{j+1}}: 
                            <span class="bold fs-14 purple">&nbsp;{{data.firstName}} {{data.lastName}} (Age:&nbsp;{{data.age}}, DOB:&nbsp;{{data.dateOfBirth | date:'ddMMMyyyy'}})</span>
                            <span class="regular fs-14 txt-lightblack2">, Days:&nbsp;</span><span class="bold fs-14 purple">{{data.policy.noOfDays}}</span>
                            <!-- <span class="regular fs-14 txt-lightblack2">, Trip Cost: </span><span class="bold fs-14 purple">{{data.tripCost}}</span> -->
                            <span class="regular fs-14 txt-lightblack2">, Arrival Date:&nbsp;</span><span class="bold fs-14 purple">{{data.arrivalDateOfCanada | date:'ddMMMyyyy'}}</span>
                            <span class="regular fs-14 txt-lightblack2">, Premium:&nbsp;</span><span class="bold fs-14 purple">{{data.premium}}</span>
                        </label>
    
                      <!-- <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Insured {{j+1}}</label>
                          <div class="bold fs-14 purple">{{data.firstName}} {{data.lastName}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Age</label>
                          <div class="bold fs-14 purple">{{data.age}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">DOB</label>
                          <div class="bold fs-14 purple">{{data.dateOfBirth}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Days</label>
                          <div class="bold fs-14 purple">{{data.policy.noOfDays}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Premium</label>
                          <div class="bold fs-14 purple">{{data.premium}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Trip Cost</label>
                          <div class="bold fs-14 purple">{{data.tripCost}}</div>
                      </div> -->
                      <!-- <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Arrival Date</label>
                          <div class="bold fs-14 purple">{{data.arrivalDateOfCanada | date:'MM/dd/yyyy'}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Option</label>
                          <div class="bold fs-14 purple"></div>
                      </div> -->
                  </div>
                  <div class="clear5"></div>
                <!-- <div class="row">
                    <span class="regular fs-14 txt-lightblack2">Deductible Option: </span><span class="bold fs-14 purple">{{data.deductableOption}}</span>
                    <span class="regular fs-14 txt-lightblack2">, Deductible Option Premium: </span><span class="bold fs-14 purple">{{data.deductableOptionPremium}}</span>
                </div> -->
                <div class="row">
                    <span class="regular fs-14 txt-lightblack2">Institute:&nbsp;</span><span class="bold fs-14 purple">{{data.insitute}}</span>
                    <span *ngIf="!NonResidentSelected" class="regular fs-14 txt-lightblack2">, Home Country:&nbsp;</span><span class="bold fs-14 purple">{{data.homeCountry}}</span>
                    <span class="regular fs-14 txt-lightblack2">, Wait Period:&nbsp;</span><span class="bold fs-14 purple">{{data.waitPeroid}}</span>
                </div>
                <!-- <div class="clear5"></div>
                <div class="row">
                    <span class="regular fs-14 txt-lightblack2">Wait Period: </span><span class="bold fs-14 purple">{{data.waitPeroid}}</span>
                    <span class="regular fs-14 txt-lightblack2">, Wait Period Premium: </span><span class="bold fs-14 purple">{{data.waitPeriodPremium}}</span>
                </div> -->
                  <!-- <div class="clear10"></div>
                  <div class="row">
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Arrival Date</label>
                          <div class="bold fs-14 purple">{{data.arrivalDateOfCanada | date:'MM/dd/yyyy'}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Deductible Option</label>
                          <div class="bold fs-14 purple">{{data.deductableOption}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Deductible Option Premium</label>
                          <div class="bold fs-14 purple">{{data.deductableOptionPremium}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Wait Period</label>
                          <div class="bold fs-14 purple">{{data.waitPeroid}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Wait Period Premium</label>
                          <div class="bold fs-14 purple">{{data.waitPeriodPremium}}</div>
                      </div>
                  </div> -->
                  </div>
              </div>
              <div class="clear10"></div>
            <div class="row">
                <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 p-1">
                    <div class="whitebox1 h158">
                        <label class="bold fs-16 txt-red m-0">Other Info</label>
                        <div class="row">
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                <label class="regular fs-14 txt-lightblack2">EOC Number:</label>
                            </div>
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                <label class="bold fs-14 purple">{{item.eocNumber}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                <label class="regular fs-14 txt-lightblack2">COC Number:</label>
                            </div>
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                <label class="bold fs-14 purple">{{item.cocNumber}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                <label class="regular fs-14 txt-lightblack2">DOC Number:</label>
                            </div>
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                <label class="bold fs-14 purple">{{item.docNumber}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                <label class="regular fs-14 txt-lightblack2">Ref Number:</label>
                            </div>
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                <label class="bold fs-14 purple">{{item.referanceNumber}}</label>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 p-1">
                    <div class="whitebox1 h158">
                        <div class="row">
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                <label class="bold fs-16 txt-red m-0">Fulfillment</label>
                            </div>
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 text-right">
                                <label class="bold fs-14 newBtn cp"  (click)="printPopup=!printPopup">New</label>
                            </div>
                        </div>
                        <div class="row" *ngFor="let fulfildata of item.fulfillments; let k=index">
                            <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                <label class="bold fs-14 purple breakAll">{{fulfildata.email}}</label>
                            </div>
                            <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 text-right">
                                <label class="regular fs-14 txt-lightblack2">{{fulfildata.createdAt | date:'ddMMMyyyy'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 p-1">
                    <div class="whitebox1 h158">
                        <label class="bold fs-16 txt-red m-0">Policy Contacts</label>
                        <div class="row">
                            <!-- <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                <label class="regular fs-14 txt-lightblack2">Purchase:</label>
                            </div> -->
                            <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                                <label class="bold fs-14 purple">{{item.purchaserName}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 p-1">
                    <div class="whitebox1 h158">
                        <label class="bold fs-16 txt-red m-0">Change History</label>
                        <div class="row " *ngFor="let policyHistoriesData of item.policyHistories; let k=index">
                            <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                <label class=" regular tooltip1 cp fs-14 txt-lightblack2">{{policyHistoriesData.status}}:
                                    <div class="tooltiptext1 regular fs-14">
                                        <span class="whitespacenormal italic tooltiptext2"> <span class="wordbreakall">User: {{policyHistoriesData.lastModifiedBy ||" "}}, </span><br><span class="wordbreakall"> Agent: {{policyHistoriesData.agentId.agentCode ||" "}}-{{policyHistoriesData.agentId.agentUserId ||" "}}</span></span>
                                        </div>
                                </label>
                            </div>
                            <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                                <label class="bold fs-14 tooltip1 cp purple">{{policyHistoriesData.updatedAt | date:'ddMMMyyyy'}}
                                    <div class="tooltiptext1 regular fs-14">
                                        <span class="whitespacenormal italic tooltiptext2"> <span class="wordbreakall">User: {{policyHistoriesData.lastModifiedBy ||" "}}, </span><br><span class="wordbreakall"> Agent: {{policyHistoriesData.agentId.agentCode ||" "}}-{{policyHistoriesData.agentId.agentUserId ||" "}}</span></span>
                                        </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
              <div class="clear10"></div>
              <div class="whitebox1">
                  <label class="bold fs-16 txt-red m-0">Payments</label>
                  
                  <div class="tableheadFix1">
                    <table id="tablePayment" class="w100">
                        <thead class="nowrap">
                            <tr>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Payment Date</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Type</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Amount</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Admin Fee</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Card Number</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Exp (mmyy)</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Card Processing</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Action</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="">
                            <tr *ngFor="let data of item.transactions;let i=index">
                                <td>{{data.transactionPaymentDetails[0].sslTxnTime | date:'ddMMMyyyy'}}</td>
                                <td>{{data.transactionPaymentDetails[0].sslTransactionType}}</td>                      
                                <td>{{data.transactionPaymentDetails[0].sslAmount}}</td>                      
                                <td>{{data.transactionPaymentDetails[0].adminFee}}</td>                      
                                <td>{{data.transactionPaymentDetails[0].sslCardNumber}}</td> 
                                <td>{{data.transactionPaymentDetails[0].sslExpDate}}</td>
                                <td>{{data.transactionPaymentDetails[0].sslResultMessage}}</td>
                                <td><u class="link cp" (click)="viewmoreIndex(i);viewPaymentDetailsPopup=!viewPaymentDetailsPopup">View More</u></td>                     
                            </tr>
                        </tbody>
                    </table>
                </div>
                  <!-- <div class="clear5"></div>
                  <div class="border-bottom"></div>
                  <div class="clear5"></div>
                  <div class="row">
                    
                 
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Date</label>
                          <div class="bold fs-14 purple">{{item.transactions[0].transactionPaymentDetails[0].createdAt | date:'MM/dd/yyyy'}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Type</label>
                          <div class="bold fs-14 purple">{{item.transactions[0].transactionPaymentDetails[0].sslTransactionType}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Payment Amount</label>
                          <div class="bold fs-14 purple">{{item.transactions[0].transactionPaymentDetails[0].sslAmount}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Admin Fee</label>
                          <div class="bold fs-14 purple">{{item.transactions[0].transactionDetails[0].adminFee}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Card Number</label>
                          <div class="bold fs-14 purple">{{item.transactions[0].transactionPaymentDetails[0].sslCardNumber}}</div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Expiry Date</label>
                          <div class="bold fs-14 purple">{{item.transactions[0].transactionPaymentDetails[0].sslExpDate}}</div>
                      </div>
                  </div>
                  <div class="clear10"></div>
                  <div class="row">
                      <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                          <label class="regular fs-14 txt-lightblack2">Result Message</label>
                          <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslResultMessage}}</u></div>
                      </div>
                      <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                          <label class="regular fs-14 txt-lightblack2">Merchant Initiated Unscheduled</label>
                          <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslMerchantInitiatedUnscheduled}}</u></div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Issuer Response</label>
                          <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslIssuerResponse}}</u></div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">Partner App ID</label>
                          <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslPartnerAppId}}</u></div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                          <label class="regular fs-14 txt-lightblack2">OAR Data</label>
                          <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslOarData}}</u></div>
                      </div>
                  </div>
                  <div class="clear10"></div>
                    <div class="row">
                      <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                          <label class="regular fs-14 txt-lightblack2">Transaction Reference Number</label>
                          <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslTransactionReferenceNumber}}</u></div>
                      </div>
                      <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                        <label class="regular fs-14 txt-lightblack2">Transaction ID</label>
                          <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslTxnId}}</u></div>
                          
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Transaction Time</label>
                        <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslTxnTime | date:'MM/dd/yyyy'}}</u></div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Currency</label>
                          <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslTransactionCurrency}}</u></div>
                       
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Approval Code</label>
                        <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslApprovalCode}}</u></div>
                      </div>
                    </div>
                    <div class="clear10"></div>
                    <div class="row">
                      <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                          <label class="regular fs-14 txt-lightblack2">Sales Tax</label>
                          <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslSalestax}}</u></div>
                      </div>
                      <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                        
                          <label class="regular fs-14 txt-lightblack2">AVS Response</label>
                          <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslAvsResponse}}</u></div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Result</label>
                        <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslResult}}</u></div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Account Balance</label>
                        <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslAccountBalance}}</u></div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">PS 2000 Data</label>
                        <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslPs2000Data}}</u></div>
                      </div>
                    </div>
                    <div class="clear10"></div>
                    <div class="row">
                      <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                          <label class="regular fs-14 txt-lightblack2">Card Short Description</label>
                          <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslCardShortDescription}}</u></div>
                      </div>
                      <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                        <label class="regular fs-14 txt-lightblack2">Card Type</label>
                        <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslCardType}}</u></div>
                       
                          
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">CVV2 Response</label>
                        <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslCvv2Response}}</u></div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Get Token</label>
                        <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslGetToken}}</u></div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                        <label class="regular fs-14 txt-lightblack2">Token Response</label>
                        <div class="bold fs-14 purple"><u>{{item.transactions[0].transactionPaymentDetails[0].sslTokenResponse}}</u></div>
                       
                      </div>
                    </div>
                  </div> -->
              </div>
             
              <div class="clear20"></div>
              <div class="whitebox1" >
                  <label class="bold fs-16 txt-red m-0">Notes</label>&nbsp;&nbsp;
                  <label class="bold fs-14 newBtn cp" (click)="openNewNotePopup()">New</label>
                  <div class="tableheadFix1">
                    <table id="tablePayment" class="w100">
                        <thead class="nowrap">
                            <tr>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Date Created</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Created By</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Type</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Note Text</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="">
                            <tr *ngFor="let data of item.policyNotes">
                                <td>{{data.createdAt | date:'ddMMMyyyy'}}</td>
                                <td>{{data.createdBy}}</td>                      
                                <td>{{data.type}}</td>                      
                                <td>{{data.noteText}}</td>                                          
                            </tr>
                        </tbody>
                    </table>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div id="showPaymentHistoryPopup" class="modal" [style.display]="showPaymentHistoryPopup ? 'block' : 'none'">
        <!-- Modal content -->
        <div class="modal-dialog modal-lg">
            <div class="modal-content w-100">
              <div class="modal-header">
                <span class="fs-16 text46 semi-bold">Payment History</span>
                <h6 class="close text-right" (click)="showPaymentHistoryPopup=!showPaymentHistoryPopup">&times;</h6>
            </div>
                <div class="modal-body m-0">
                  <div class="tableheadFix">
                    <table id="tableheadFixMonthlyPay" class="w100">
                        <thead class="nowrap">
                            <tr>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>DATE</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>Type</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>PAYMENT AMOUNT</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>ADMIN FEE</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>CARD NUMBER</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>EXP (MMYY)</span>
                                        <!-- <div class="d-flex flex-column ml-4">
                                            <i class="fa fa-caret-up"></i>
                                            <i class="fa fa-caret-down"></i>
                                        </div> -->
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="">
                            <tr>
                                <td>Dummy</td>
                                <td>Dummy</td>                      
                                <td>Dummy</td>                      
                                <td>Dummy</td>                      
                                <td>Dummy</td> 
                                <td>Dummy</td>                      
                            </tr>
                            <tr>
                              <td>Dummy</td>
                              <td>Dummy</td>                      
                              <td>Dummy</td>                      
                              <td>Dummy</td>                      
                              <td>Dummy</td> 
                              <td>Dummy</td>                      
                          </tr><tr>
                            <td>Dummy</td>
                            <td>Dummy</td>                      
                            <td>Dummy</td>                      
                            <td>Dummy</td>                      
                            <td>Dummy</td> 
                            <td>Dummy</td>                      
                        </tr><tr>
                          <td>Dummy</td>
                          <td>Dummy</td>                      
                          <td>Dummy</td>                      
                          <td>Dummy</td>                      
                          <td>Dummy</td> 
                          <td>Dummy</td>                      
                      </tr>
                        </tbody>
                    </table>
                </div>
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right">
                            <button type="button" class="olnone fs-16 semi-bold dltclosebtn text46 mr-2" (click)="showPaymentHistoryPopup=!showPaymentHistoryPopup">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div id="viewPaymentDetailsPopupClass" class="modal" [style.display]="viewPaymentDetailsPopup ? 'block' : 'none'">
          <div  *ngIf="viewPaymentDetailsPopup">
        <div class="modal-content" *ngFor="let item of policyIDDetail;let i=index">
              <div class="modal-header">
                  <div class="row">
                      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                          <label class="fs-16 text46 bold">Payment Details : {{item.transactions[viewMoreIndex].transactionPaymentDetails[0].createdAt | date:'MM/dd/yyyy'}}</label><br>
                      </div>
                      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 text-right">
                          <h6 class="fs-20 bold text-right cp" (click)=" this.viewPaymentDetailsPopup = !this.viewPaymentDetailsPopup">&times;</h6>
                      </div>
                  </div>
              </div>
              <div class="modal-body">
                  <div class="row">
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Result Message:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslResultMessage}}</label>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Currency:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslTransactionCurrency}}</label>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Card Short Description:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslCardShortDescription}}</label>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Issuer Response:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslIssuerResponse}}</label>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Approval Code:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslApprovalCode}}</label>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Card Type:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslCardType}}</label>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Partner App ID:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslPartnerAppId}}</label>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Sales Tax:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslSalestax}}</label>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">CVV2 Response:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslCvv2Response}}</label>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">OAR Data:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple breakAll">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslOarData}}</label>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">AVS Response:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple breakAll">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslAvsResponse}}</label>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Get Token:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslGetToken}}</label>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Transaction Reference No:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple breakAll">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslTransactionReferenceNumber}}</label>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Result:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslResult}}</label>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Token Response:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslTokenResponse}}</label>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Transaction ID:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple breakAll">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslTxnId}}</label>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Account Balance:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslAccountBalance}}</label>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Merchant Initiated Unscheduled:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslMerchantInitiatedUnscheduled}}</label>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">Transaction Date-Time:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslTxnTime | date:'MM/dd/yyyy hh:mm:ss'}}</label>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <div class="row">
                              <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12">
                                  <label class="regular fs-14 txt-lightblack2">PS 2000 Data:</label>
                              </div>
                              <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                                  <label class="bold fs-14 purple">{{item.transactions[viewMoreIndex].transactionPaymentDetails[0].sslPs2000Data}}</label>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="clear20"></div>
                  <div class="text-right">
                      <button type="button" class="fs-14 bold addbtn" (click)="viewPaymentDetailsPopup =! viewPaymentDetailsPopup">Close</button>
                  </div>
              </div>
          </div>
        </div>
        </div>
        <div id="newNotePopupClass" class="modal" [style.display]="newNotePopup ? 'block' : 'none'">
          <div class="modal-content">
              <div class="modal-header">
                  <div class="row">
                      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                          <label class="fs-16 text46 bold">New Note</label><br>
                      </div>
                      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 text-right">
                          <h6 class="fs-20 bold text-right cp" (click)=" this.newNotePopup = !this.newNotePopup">&times;</h6>
                      </div>
                  </div>
              </div>
              <div class="modal-body">
                  <div class="row">
                      <!-- <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <label class="regular fs-14 txt-lightblack2">Type</label>
                      </div> -->
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <label class="regular fs-14 txt-lightblack2">Date Created</label>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <label class="regular fs-14 txt-lightblack2">Created By</label>
                      </div>
                  </div>
                  <div class="row">
                      <!-- <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <ng-select placeholder="Select" class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-12" [(ngModel)]="noteType">
                              <ng-option *ngFor="let data of notesSatusData" [value]="data">{{data}}</ng-option>
                          </ng-select>
                      </div> -->
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <input class="form-control disabledinputBox col-sm-10 col-md-10 col-lg-10 col-xl-10 col-12" placeholder="MM-DD-YYYY" [(ngModel)]="createdDate" disabled >
                          <!-- <owl-date-time [pickerType]="'calendar'" #dt55></owl-date-time> -->
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                          <input type="text" class="form-control disabledinputBox col-sm-10 col-md-10 col-lg-10 col-xl-10 col-12" disabled [(ngModel)]="loggedInUserName" placeholder="Name">
                      </div>
                  </div>
                  <div class="clear20"></div>
                  <div class="row">
                      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                          <label class="regular fs-14 txt-lightblack2">Note Text</label>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                          <textarea rows=4 placeholder="Type here" class="textarea w100" [(ngModel)]="noteText"></textarea>
                      </div>
                  </div>
                  <div class="clear20"></div>
                  <div class="text-right">
                      <button type="button" class="fs-14 bold addbtn" (click)="addNotesToPolicy()">Save</button>
                  </div>
              </div>
          </div>
        </div>
      <div id="printPopup" class="modal" [style.display]="printPopup ? 'block' : 'none'">
          <div class="modal-content">
              <div class="modal-header">
                  <div class="row">
                      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                          <label class="fs-16 text46 bold">Email</label><br>
                      </div>
                      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 text-right">
                          <h6 class="fs-20 bold text-right cp" (click)=" this.printPopup = !this.printPopup">&times;</h6>
                      </div>
                  </div>
              </div>
              <div class="modal-body">
                  <label class="fs-16 text46 regular">Share with</label><br>
                  <div>
                      <input type="text" class="form-control forminput1 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12" [(ngModel)]="email1" placeholder="example@gmail.com" (input)="onRemoveEmailError()">
                      <p class="regular redstar" *ngIf="emailErrorFlag">Email is required</p>
                  </div>
                  <div class="clear20"></div>
                  <div>
                      <input type="text" class="form-control forminput1 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12" [(ngModel)]="email2" placeholder="example@gmail.com">
                  </div>
                  <div class="clear20"></div>
                  <label class="bold fs-14 txt-red">Previous Fulfillments</label>
                  <!-- <div class="row" *ngFor="let data of fulfillments">
                      <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                          <label class="bold fs-14 purple breakAll">{{data.email}}</label>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">
                          <label class="regular fs-14 txt-lightblack2">{{data.createdAt | date:'ddMMMyyyy'}}</label>
                      </div>
                  </div> -->
                  <div class="row" *ngFor="let data of fulfillments">
                    <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                        <label class="bold fs-14 purple breakAll">{{data.email}}</label>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 text-right">
                        <label class="regular fs-14 txt-lightblack2">{{data.createdAt | date:'ddMMMyyyy'}}</label>
                    </div>
                </div>
                  <div class="clear20"></div>
                  <div class="text-right">
                      <button type="button" class="fs-14 bold addbtn" (click)="onSendEmail()">Send</button>
                  </div>
              </div>
          </div>
        </div>